/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import arClient from '../../util/api_client';
import { OK, LEGACY_OK } from '../../constants/platformStatusCodes';
// import { fa } from './static/fetchAll';
import { HypeAuditorFilters } from './static/hypeAuditorFilters';
import { ModashFilters } from './static/hypeAuditorFilters';
import {
  formatCreatorDataListing,
  formatCreatorDataListingV3,
} from './Utils/creatorsLib';
import { formatContentData } from './Utils/formatContentData';
import getTotalPostCommentsCount from './Utils/getTotalPostCommentsCount';
import reconcileCreatorFiltersData from './Utils/reconcileCreatorFiltersData';
import { API_HOST, ENV } from '../../constants/apiUrls';
import { MAGIC_LINK_INFLUENCER_DISPLAY } from '../../constants/internalConsts';
import {
  brandSafetyFlagTotal,
  mergeBrandSafetyCheck,
} from '../Campaigns/components/RunBrandSafetyCheckModal/brandSafetyContract';

/**
 * Public API call for magic link endpoints — NO auth token required.
 * Magic link endpoints are hash-validated (magicLinkId + hashCode),
 * not token-validated. arClient.doApiCall() requires a Bearer token
 * and silently fails for non-authenticated visitors.
 */
const magicLinkApiCall = async (endpoint, data) => {
  const response = await fetch(`${API_HOST}${endpoint}`, {
    credentials: 'include',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return response.json();
};
import { formatContentAnalysisData } from './CreatorDetailsPage/formatContentAnalysisData';
import { BRAND_SAFETY_LABELS } from './BrandSafety/brandSafetyConsts';
import { parseUserFeedbackRecord } from './BrandSafety/brandSafetyHelper';
import stripFroalaAttribution from '../../util/stripFroalaAttribution';

/**
 * Every brand safety flag switched on. Used as the initial value and as the fallback
 * whenever the preference cannot be read, so a failed lookup never hides flags.
 *
 * @returns {Object<string, boolean>} Flag key to enabled, all true
 */
const allBrandSafetyFlagsEnabled = () => _.mapValues(BRAND_SAFETY_LABELS, () => true);

const initialState = {
  personaList: [],
  personaListLoading: false,
  personaListCache: {},

  personaCreationSelectedCampaigns: '',
  personaCreationAvaliableInterests: [],
  personaCreationAvaliableInterestsLoading: false,
  personaCreationSuggestedInterests: [],
  personaCreationSuggestedInterestsCanceled: false,
  personaCreationSelectedInterests: [],
  personaHashtagKeywordsCanceled: false,
  personaHashtagKeywords: [],
  personaSEOKeywordsCanceled: false,
  personaSEOKeywords: [],

  personaCreationFiltersActiveNetwork: 'instagram',
  personaCreationFiltersisLoading: true,
  personaCreationFiltersValidationErrors: {
    similarAsError: null,
    advancedFieldsError: null,
  },
  personaCreationFilters: {
    instagram: {
      selectedForSubmit: false,
      isSaving: false,
      isUntouched: true,
      invalidFields: [],
      selectedFilters: {
        social_network: 'instagram',
        influencer_followers: { min: 100000, max: 300000 },
        // account_geo: {
        //   country: ['us'],
        // },
        audience_location: [
          {
            id: 148838,
            label: 'United States',
            weight: 0.5,
          },
        ],
      },
      noMaxLimit: false,
      LDACompliance: null,
      filters: {
        // income: {
        //   id: '50k',
        //   prc: 30,
        // },
        social_network: 'instagram',
        // ...HypeAuditorFilters,
        ...ModashFilters,
      },
    },
    tiktok: {
      selectedForSubmit: false,
      isSaving: false,
      isUntouched: true,
      invalidFields: [],
      selectedFilters: {
        social_network: 'tiktok',
        influencer_followers: { min: 100000, max: 300000 },
        // account_geo: {
        //   country: ['us'],
        // },
        audience_location: [
          {
            id: 148838,
            label: 'United States',
            weight: 0.5,
          },
        ],
      },
      noMaxLimit: false,
      LDACompliance: null,
      filters: {
        social_network: 'tiktok',
        // views_avg: {
        //   from: 5000,
        //   to: 50000,
        // },
        // comments_avg: { from: 10 },
        // alikes_avg: { from: 10 },
        // likes_growth_prc: {
        //   period: '90d',
        //   from: 20,
        // },
        // likes_count: {
        //   from: 5000,
        //   to: 50000,
        // },
        // ...HypeAuditorFilters,
        ...ModashFilters,
      },
    },
    youtube: {
      selectedForSubmit: false,
      isSaving: false,
      isUntouched: true,
      invalidFields: [],
      selectedFilters: {
        social_network: 'youtube',
        influencer_followers: { min: 100000, max: 300000 },
        // account_geo: {
        //   country: ['us'],
        // },
        audience_location: [
          {
            id: 148838,
            label: 'United States',
            weight: 0.5,
          },
        ],
      },
      noMaxLimit: false,
      LDACompliance: null,
      filters: {
        social_network: 'youtube',
        // views_avg: { from: 5000, to: 50000 },
        // comments_avg: { from: 10 },
        // alikes_avg: { from: 10 },
        // reactions_rate: ['any'],
        // ...HypeAuditorFilters,
        ...ModashFilters,
      },
    },
    twitter: {
      selectedForSubmit: false,
      isSaving: false,
      isUntouched: true,
      invalidFields: [],
      selectedFilters: {
        social_network: 'twitter',
        subscribers_count: { from: 100000, to: 300000 },
      },
      LDACompliance: null,
      noMaxLimit: false,
      filters: {
        social_network: 'twitter',
        ...HypeAuditorFilters,
      },
    },
    twitch: {
      selectedForSubmit: false,
      isSaving: false,
      isUntouched: true,
      invalidFields: [],
      selectedFilters: {
        social_network: 'twitch',
        subscribers_count: { from: 100000, to: 300000 },
      },
      noMaxLimit: false,
      LDACompliance: null,
      filters: {
        social_network: 'twitch',
        ...HypeAuditorFilters,
      },
    },
  },

  personaResultsList: [],
  personaResultsListLoading: false,

  PersonaCreateErrorMsg: '',
  PersonaCreateSuccess: false,
  PersonaCreateBuilderRequestDataId: null,

  PersonaStatusUpdateLoading: false,

  CreatorFiltersSavedSuccess: false,
  CreatorFiltersSavedErrMsg: false,

  details: {},
  detailsError: null,
  detailsLoading: true,
  postContentByIds: {},
  postContentIsLoading: false,
  commentsV2: {},
  commentsV2Cache: {},

  influencerList: [],
  influencerERList: [],
  influencerListError: null,
  isInfluencerListLoading: true,
  isInfluencerERListLoading: true,
  influencerDetails: {},
  influencerDetailsLoading: true,

  influencerNotes: [],
  influencerNotesLoading: false,

  influencersBrandSaftey: [],
  influencersBrandSafteyLoading: false,
  postBrandSafetyFeedbackArr: [],
  campaignBrandSafetyPreference: allBrandSafetyFlagsEnabled(),
  // Campaign whose preference is currently in `campaignBrandSafetyPreference` — the fetch-once guard
  // (same idiom as `campaignCreatorsFetchedId`). Saving a preference keeps it set, since the save
  // already writes the fresh map to state; a different campaign clears it by mismatching.
  campaignBrandSafetyPreferenceFetchedId: null,

  chatAnswers: [],

  isCompareActive: false,
  comparePersonaCampaign: '',
  selectedPersonaForCompArr: [],

  influencerContent: [],
  isInfluencerContentLoading: false,

  audienceList: [],
  isAudienceListLoading: false,

  isInfluencerRevisionsFound: false,
  isInfluencerRevisionsFoundLoading: false,

  influencerRevisionsList: [],
  isInfluencerRevisionsListLoading: false,

  influencerRevisionsConversation: {},
  isInfluencerRevisionsConversationLoading: false,
  contentAgreementData: null,
  selectedContentRevisionId: '',

  influencerMatchingContent: [],
  influencerMatchingContentLoading: false,

  personasLiteList: [],
  personasLiteListLoading: false,
  magicLinkData: false,

  commentsBreakdown: {},
  isLoadingCommentsBreakdown: false,
  commentsBreakdownCache: {},

  influencersHeroList: [],
  isInfluencerHeroListLoading: false,

  influencerCount: [],
};

const PersonasSlice = createSlice({
  name: 'Personas',
  initialState,
  reducers: {
    setPostContentByIds(state, action) {
      const { payload } = action;
      state.postContentByIds = payload;
    },

    setPostContentIsLoading(state, action) {
      const { payload } = action;
      state.postContentIsLoading = payload;
    },

    setCommentsV2(state, action) {
      const { payload } = action;
      state.commentsV2 = payload;
    },

    setCommentsV2Cache(state, action) {
      const { payload } = action;
      const { cacheKey, data } = payload;
      state.commentsV2Cache[cacheKey] = data;
    },

    clearCommentsV2Cache(state) {
      state.commentsV2Cache = {};
    },

    setPersonaListCache(state, action) {
      const { payload } = action;
      const { cacheKey, data } = payload;
      state.personaListCache[cacheKey] = data;
    },

    clearPersonaListCache(state) {
      state.personaListCache = {};
    },

    resetPersonaList(state) {
      state.personaList = initialState.personaList;
    },

    setPersonaList(state, action) {
      const { payload } = action;
      state.personaList = payload;
    },

    setPersonaListLoading(state, action) {
      const { payload } = action;
      state.personaListLoading = payload;
    },

    setPersonaCreationSelectedCampaigns(state, action) {
      const { payload } = action;
      state.personaCreationSelectedCampaigns = payload;
    },

    setPersonaCreationAvaliableInterests(state, action) {
      const { payload } = action;
      state.personaCreationAvaliableInterests = payload;
    },

    setPersonaCreationAvaliableInterestsLoading(state, action) {
      const { payload } = action;
      state.personaCreationAvaliableInterestsLoading = payload;
    },

    setPersonaCreationSuggestedInterests(state, action) {
      const { payload } = action;
      state.personaCreationSuggestedInterests = payload;
    },

    setPersonaCreationSuggestedInterestsCanceled(state, action) {
      const { payload } = action;
      state.personaCreationSuggestedInterestsCanceled = payload;
    },

    setPersonaCreationSelectedInterests(state, action) {
      const {
        payload: { selectedInterests },
      } = action;
      state.personaCreationSelectedInterests = selectedInterests;
    },

    setPersonaHashtagKeywords(state, action) {
      const { payload } = action;
      state.personaHashtagKeywords = payload;
    },

    setPersonaHashtagKeywordsCanceled(state, action) {
      const { payload } = action;
      state.personaHashtagKeywordsCanceled = payload;
    },

    setPersonaSEOKeywords(state, action) {
      const { payload } = action;
      state.personaSEOKeywords = payload;
    },

    setPersonaSEOKeywordsCanceled(state, action) {
      const { payload } = action;
      state.personaSEOKeywordsCanceled = payload;
    },

    // Filters
    setPersonaCreationFiltersActiveNetwork(state, action) {
      const { payload } = action;
      state.personaCreationFiltersActiveNetwork = payload;
    },

    setFiltersLoadingState(state, action) {
      const { payload } = action;
      state.personaCreationFiltersisLoading = payload;
    },

    setFiltersFromSaved(state, action) {
      const { payload } = action;
      state.personaCreationFilters = payload;
    },

    resetFiltersForNetwork(state, action) {
      const { payload } = action;
      state.personaCreationFilters[payload] =
        initialState.personaCreationFilters[payload];
    },

    setFilterValue(state, action) {
      const { payload } = action;

      state.personaCreationFilters[payload.network].filters[payload.filter] =
        payload.value;

      state.personaCreationFilters[payload.network].noMaxLimit =
        payload.noMaxLimit;

      state.personaCreationFilters[payload.network].selectedFilters[
        payload.filter
      ] = payload.value;
    },
    setFilterSysVal(state, action) {
      const { payload } = action;
      state.personaCreationFilters[payload.network][payload.filter] =
        payload.value;
    },
    setFiltersErrorsVal(state, action) {
      const { payload } = action;
      state.personaCreationFiltersValidationErrors[payload.type] =
        payload.errorText;
    },
    // Filters end

    resetResultsList(state) {
      state.personaResultsList = initialState.personaResultsList;
    },

    setResultsList(state, action) {
      const { payload } = action;
      state.personaResultsList = payload;
    },

    setResultsListLoading(state, action) {
      const { payload } = action;
      state.personaResultsListLoading = payload;
    },

    setPersonaCreateErrorMsg(state, action) {
      const { payload } = action;
      state.PersonaCreateErrorMsg = payload;
    },

    setPersonaCreateSuccess(state, action) {
      const { payload } = action;
      state.PersonaCreateSuccess = payload;
    },

    setPersonaCreateBuilderRequestDataId(state, action) {
      const { payload } = action;
      state.PersonaCreateBuilderRequestDataId = payload;
    },

    setCreatorFiltersSavedSuccess(state, action) {
      const { payload } = action;
      state.CreatorFiltersSavedSuccess = payload;
    },

    setCreatorFiltersSavedErrMsg(sate, action) {
      const { payload } = action;
      state.CreatorFiltersSavedErrMsg = payload;
    },

    // PERSONA DETAILS
    resetPersonaDetails(state) {
      state.details = initialState.details;
    },

    updatePersonaDetails(state, action) {
      const { payload } = action;
      state.details = payload;
      state.detailsError = null; // Clear error when details are updated
    },

    setDetailsError(state, action) {
      const { payload } = action;
      state.detailsError = payload;
    },

    setPersonaDetailsName(state, action) {
      const { payload } = action;
      state.details.name = payload;
    },

    setPersonaDetailsSentiment(state, action) {
      const { payload } = action;
      state.details.sentiment = payload;
    },

    setPersonaDetailsCommunity(state, action) {
      const { payload } = action;
      state.details.community = payload;
    },

    setPersonaDetailsFollowers(state, action) {
      const { payload } = action;
      state.details.followers = payload;
    },

    setPersonaDetailsCommentsNPosts(state, action) {
      const { payload } = action;
      state.details.postsComments = payload;
    },

    setPersonaDetailsSummary(state, action) {
      const { payload } = action;
      state.details.summary = payload;
    },

    setPersonaDetailsPrimaryInt(state, action) {
      const { payload } = action;
      state.details.primaryInterests = payload;
    },

    setPersonaDetailsSecondraryInt(state, action) {
      const { payload } = action;
      state.details.secondraryInterests = payload;
    },

    setPersonaDetailsTopicsTableData(state, action) {
      const { payload } = action;
      state.details.topicsTableData = payload;
    },

    setPersonaDetailsIncomeData(state, action) {
      const { payload } = action;
      state.details.incomeData = payload;
    },

    setPersonaDetailsAgeRangesData(state, action) {
      const { payload } = action;
      state.details.ageRangesData = payload;
    },

    setPersonaDetailsEthnicityData(state, action) {
      const { payload } = action;
      state.details.ethnicityData = payload;
    },

    setPersonaDetailsMapData(state, action) {
      const { payload } = action;
      state.details.mapData = payload;
    },

    setPersonaDetailsEduAndMartialData(state, action) {
      const { payload } = action;
      state.details.eduAndMartialData = payload;
    },

    setPersonaDetailsIsLoading(state, action) {
      const { payload } = action;
      state.detailsLoading = payload;
    },

    setPersonaStatusUpdateLoading(state, action) {
      const { payload } = action;
      state.PersonaStatusUpdateLoading = payload;
    },

    // Influencer listening part
    setInfluencerListContent(state, action) {
      const { payload } = action;
      state.influencerList = payload;
    },
    setInfluencerER(state, action) {
      const { payload } = action;
      state.influencerERList = payload;
    },
    setInfluencerLoadingState(state, action) {
      const { payload } = action;
      state.isInfluencerListLoading = payload;
    },
    setInfluencerListError(state, action) {
      const { payload } = action;
      state.influencerListError = payload;
    },
    setInfluencerERLoadingState(state, action) {
      const { payload } = action;
      state.isInfluencerERListLoading = payload;
    },
    setInfluencerNotesContent(state, action) {
      const { payload } = action;
      state.influencerNotes = payload;
    },
    setInfluencerNotesLoadingState(state, action) {
      const { payload } = action;
      state.influencerNotesLoading = payload;
    },
    updateInfluencerListNotes(state, action) {
      const { detailsId, notes } = action.payload;
      const record = state.influencerList.find(item => item.detailsId === detailsId);
      if (!record) return;
      record.notes = typeof notes === 'string' ? notes : JSON.stringify(notes);
    },
    /**
     * Apply a live `.checks.updated` event (Reverb) to the influencer rows: patch each matching row's
     * `brandSafetyCheck = { pipelineCheck, userCheck }` in place — the SAME shape a fetchAllV3 row carries,
     * so a live push renders identically to the 10s poll refetch — and refresh the flags total the Brand
     * Safety column + its sorter read. Rows are matched by `detailsId` (the crd on this screen). Payload =
     * the event's `creatorChecks` array (`readChecksUpdatedEvent` output: `{ crd, pipelineCheck, userCheck }`).
     * DELTA merge: only the creators that changed; every other row is left untouched. No-op on an empty payload.
     */
    applyBrandSafetyChecksUpdate(state, action) {
      const creatorChecks = Array.isArray(action.payload) ? action.payload : [];
      if (!creatorChecks.length) return;

      const byCrd = {};
      creatorChecks.forEach((check) => {
        if (check && check.crd != null) byCrd[String(check.crd)] = check;
      });

      (Array.isArray(state.influencerList) ? state.influencerList : []).forEach((row) => {
        const update = byCrd[String(row.detailsId)];
        if (!update) return;
        row.brandSafetyCheck = {
          pipelineCheck: update.pipelineCheck ?? null,
          userCheck: update.userCheck ?? null,
        };
        // Keep the column's flag count (badge + sorter) in sync with the merged verdict.
        const merged = mergeBrandSafetyCheck(row.brandSafetyCheck);
        if (merged) {
          row.brandSafety = merged.flags || {};
          row.totalFlagsBrandSafety = brandSafetyFlagTotal(merged.flags);
        }
      });
    },

    setInfluencerDetailsContent(state, action) {
      const { payload } = action;
      state.influencerDetails = payload;
    },
    setInfluencerDetailsLoadingState(state, action) {
      const { payload } = action;
      state.influencerDetailsLoading = payload;
    },
    setInfluencerDetailsInsight(state, action) {
      const { payload } = action;
      state.influencerDetails.all.insights = payload;
    },
    setInfluencerDetailsProsCons(state, action) {
      const { payload } = action;
      state.influencerDetails.all.prosCons = payload;
    },
    setChatGPTAnswers(state, action) {
      const { payload } = action;
      state.chatAnswers = [...state.chatAnswers, payload];
    },
    setIsCompareActive(state, action) {
      const { payload } = action;
      state.isCompareActive = payload;
    },
    setComparePersonaCampaign(state, action) {
      const { payload } = action;
      state.comparePersonaCampaign = payload;
    },
    setSelectedPersonaForCompArr(state, action) {
      const { payload } = action;
      state.selectedPersonaForCompArr = payload;
    },
    resetChatGPTAnswers(state, action) {
      state.chatAnswers = initialState.chatAnswers;
    },
    setInfluencerContent(state, action) {
      const { payload } = action;
      state.influencerContent = payload;
    },
    setInfluencerContentLoadingState(state, action) {
      const { payload } = action;
      state.isInfluencerContentLoading = payload;
    },
    setAudienceList(state, action) {
      const { payload } = action;
      state.audienceList = payload;
    },
    setAudienceListLoadingState(state, action) {
      const { payload } = action;
      state.isAudienceListLoading = payload;
    },
    setIsInfluencerRevisionsFound(state, action) {
      const { payload } = action;
      state.isInfluencerRevisionsFound = payload;
    },
    setIsInfluencerRevisionsFoundLoading(state, action) {
      const { payload } = action;
      state.isInfluencerRevisionsFoundLoading = payload;
    },
    setInfluencerRevisionsList(state, action) {
      const { payload } = action;
      state.influencerRevisionsList = payload;
    },
    setIsInfluencerRevisionsListLoading(state, action) {
      const { payload } = action;
      state.isInfluencerRevisionsListLoading = payload;
    },
    setInfluencerRevisionsConversation(state, action) {
      const { payload } = action;
      state.influencerRevisionsConversation = payload;
    },
    setIsInfluencerRevisionsConversationLoading(state, action) {
      const { payload } = action;
      state.isInfluencerRevisionsConversationLoading = payload;
    },
    setContentAgreementData(state, action) {
      const { payload } = action;
      state.contentAgreementData = payload;
    },
    setSelectedContentRevisionId(state, action) {
      const { payload } = action;
      state.selectedContentRevisionId = payload;
    },
    setInfluencersBrandSafteyData(state, action) {
      const { payload } = action;
      state.influencersBrandSaftey = payload;
    },
    setInfluencersBrandSafteyLoading(state, action) {
      const { payload } = action;
      state.influencersBrandSafteyLoading = payload;
    },
    setInfluencerMatchingContent(state, action) {
      const { payload } = action;
      state.influencerMatchingContent = payload;
    },
    setInfluencerMatchingContentLoading(state, action) {
      const { payload } = action;
      state.influencerMatchingContentLoading = payload;
    },
    setPersonaLiteList(state, action) {
      const { payload } = action;
      state.personasLiteList = payload;
    },
    setPersonaLiteListLoading(state, action) {
      const { payload } = action;
      state.personasLiteListLoading = payload;
    },
    setPostBrandSafetyFeedbackArr(state, action) {
      const { payload } = action;
      state.postBrandSafetyFeedbackArr = payload;
    },

    setCampaignBrandSafetyPreference(state, action) {
      const { payload } = action;
      state.campaignBrandSafetyPreference = payload;
    },

    setCampaignBrandSafetyPreferenceFetchedId(state, action) {
      const { payload } = action;
      state.campaignBrandSafetyPreferenceFetchedId = payload;
    },

    setCommentsBreakdown(state, action) {
      const { payload } = action;
      state.commentsBreakdown = payload;
    },

    setIsLoadingCommentsBreakdown(state, action) {
      const { payload } = action;
      state.isLoadingCommentsBreakdown = payload;
    },

    setCommentsBreakdownCache(state, action) {
      const { payload } = action;
      const { cacheKey, data } = payload;
      state.commentsBreakdownCache[cacheKey] = data;
    },

    setInfluencerHeroList(state, action) {
      const { payload } = action;
      state.influencersHeroList = payload;
    },

    setIsLoadingInfluencerHeroList(state, action) {
      const { payload } = action;
      state.isInfluencerHeroListLoading = payload;
    },
    setInfluencerCount(state, action) {
      const { payload } = action;
      state.influencerCount = payload;
    },
  },
});

export const {
  resetPersonaList,
  setPersonaList,
  setPersonaListLoading,
  setPersonaCreationSelectedCampaigns,
  setPersonaCreationAvaliableInterests,
  setPersonaCreationAvaliableInterestsLoading,
  setPersonaCreationSuggestedInterests,
  setPersonaCreationSuggestedInterestsCanceled,
  setPersonaCreationSelectedInterests,
  setPersonaCreationFiltersActiveNetwork,
  setFiltersLoadingState,
  setFiltersFromSaved,
  resetFiltersForNetwork,
  setFilterValue,
  setFilterSysVal,
  setFiltersErrorsVal,
  resetResultsList,
  setResultsList,
  setResultsListLoading,
  setPersonaCreateErrorMsg,
  setPersonaCreateSuccess,
  setPersonaCreateBuilderRequestDataId,
  setCreatorFiltersSavedErrMsg,
  setCreatorFiltersSavedSuccess,
  resetPersonaDetails,
  setPersonaDetailsName,
  setPersonaDetailsSentiment,
  setPersonaDetailsCommunity,
  setPersonaDetailsFollowers,
  setPersonaDetailsCommentsNPosts,
  setPersonaDetailsSummary,
  setPersonaDetailsPrimaryInt,
  setPersonaDetailsSecondraryInt,
  setPersonaDetailsTopicsTableData,
  setPersonaDetailsIncomeData,
  setPersonaDetailsAgeRangesData,
  setPersonaDetailsEthnicityData,
  setPersonaDetailsMapData,
  setPersonaDetailsEduAndMartialData,
  setPersonaDetailsIsLoading,
  setDetailsError,
  setPersonaStatusUpdateLoading,
  updatePersonaDetails,
  setPostContentIsLoading,
  setPostContentByIds,
  setInfluencerListContent,
  setInfluencerLoadingState,
  setInfluencerListError,
  setInfluencerNotesContent,
  setInfluencerNotesLoadingState,
  updateInfluencerListNotes,
  applyBrandSafetyChecksUpdate,
  setInfluencerDetailsContent,
  setInfluencerDetailsLoadingState,
  setInfluencerDetailsInsight,
  setInfluencerDetailsProsCons,
  setChatGPTAnswers,
  resetChatGPTAnswers,
  setIsCompareActive,
  setComparePersonaCampaign,
  setSelectedPersonaForCompArr,
  setInfluencerER,
  setInfluencerERLoadingState,
  setInfluencerContent,
  setInfluencerContentLoadingState,
  setPersonaHashtagKeywordsCanceled,
  setPersonaHashtagKeywords,
  setPersonaSEOKeywordsCanceled,
  setPersonaSEOKeywords,
  setAudienceList,
  setAudienceListLoadingState,
  setIsInfluencerRevisionsFound,
  setIsInfluencerRevisionsFoundLoading,
  setInfluencerRevisionsList,
  setIsInfluencerRevisionsListLoading,
  setInfluencerRevisionsConversation,
  setIsInfluencerRevisionsConversationLoading,
  setContentAgreementData,
  setSelectedContentRevisionId,
  setInfluencersBrandSafteyData,
  setInfluencersBrandSafteyLoading,
  setInfluencerMatchingContent,
  setInfluencerMatchingContentLoading,
  setPersonaLiteList,
  setPersonaLiteListLoading,
  setCommentsV2,
  setCommentsV2Cache,
  clearCommentsV2Cache,
  setPersonaListCache,
  clearPersonaListCache,
  setPostBrandSafetyFeedbackArr,
  setCampaignBrandSafetyPreference,
  setCampaignBrandSafetyPreferenceFetchedId,
  setCommentsBreakdown,
  setIsLoadingCommentsBreakdown,
  setCommentsBreakdownCache,
  setInfluencerHeroList,
  setIsLoadingInfluencerHeroList,
  setInfluencerCount,
} = PersonasSlice.actions;

export const resetAllPersonas = () => async dispatch => {
  dispatch(resetPersonaList());
};

export const clearPersonaListCacheAction = () => async dispatch => {
  dispatch(clearPersonaListCache());
};

export const getPersonaLoaderDetail = (bId, indexId, campaignId) => async (
  dispatch,
  getState
) => {
  // Create a cache key based on the parameters
  const cacheKey = `${false}_${bId}_${indexId}_${campaignId || ''}`;

  // Check if data is already cached
  const { Personas } = getState();

  if (Personas.personaListCache[cacheKey]) {
    const cachedData = Personas.personaListCache[cacheKey];
    dispatch(setPersonaList(cachedData));

    if (bId !== false) {
      // Use custom predicate to handle string/number type mismatch from URL params
      const req = _.find(cachedData, item => String(item.builderRequestId) === String(bId));

      // Handle both data structures:
      // 1. respData is an array/indexed object: use respData[indexId]
      // 2. respData is the persona object itself (has outline, promptDetails, user_input, etc.): use respData directly
      let personaData = null;
      if (req?.respData) {
        if (req.respData[indexId] !== undefined) {
          personaData = _.cloneDeep(req.respData[indexId]);
        } else if (
          req.respData.promptDetails !== undefined ||
          req.respData.user_input !== undefined ||
          req.respData.outline !== undefined ||
          req.respData.demographicsV3 !== undefined
        ) {
          personaData = _.cloneDeep(req.respData);
        }
      }

      if (personaData) {
        const { primaryInterests } = personaData;
        if (!_.isArray(primaryInterests)) {
          // convert the old structure to the new one
          personaData.primaryInterests = _.keys(primaryInterests);
        }
        dispatch(updatePersonaDetails(personaData));
      }
      dispatch(setPersonaDetailsIsLoading(false));
    }
    dispatch(setPersonaListLoading(false));
    return;
  }

  const callback = resp => {
    // dispatch(setPersonaDetailsIsLoading(false));
    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
      // Normalize new single-segment response { audienceId, segment: {...} }
      // to the same array shape the rest of the logic expects
      const isNewFormat = resp.data && !Array.isArray(resp.data) && resp.data.segment;
      const normalizedData = isNewFormat ? [resp.data.segment] : resp.data;

      // Store data in cache
      dispatch(setPersonaListCache({ cacheKey, data: normalizedData }));
      // dispatch(setResultsList(resp.data));
      dispatch(setPersonaList(normalizedData));

      if (bId !== false) {
        // Use custom predicate to handle string/number type mismatch from URL params
        const req = _.find(normalizedData, item => String(item.builderRequestId) === String(bId));

        // Handle both data structures:
        // 1. respData is an array/indexed object: use respData[indexId]
        // 2. respData is the persona object itself (has outline, promptDetails, user_input, etc.): use respData directly
        let personaData = null;
        if (req?.respData) {
          if (req.respData[indexId] !== undefined) {
            // respData is indexed (array or object with numeric keys)
            personaData = _.cloneDeep(req.respData[indexId]);
          } else if (
            req.respData.promptDetails !== undefined ||
            req.respData.user_input !== undefined ||
            req.respData.outline !== undefined ||
            req.respData.demographicsV3 !== undefined
          ) {
            // respData IS the persona data itself
            personaData = _.cloneDeep(req.respData);
          }
        }

        if (personaData) {
          const { primaryInterests } = personaData;
          if (!_.isArray(primaryInterests)) {
            // convert the old structure to the new one
            personaData.primaryInterests = _.keys(primaryInterests);
          }
          dispatch(updatePersonaDetails(personaData));
        }
        dispatch(setPersonaDetailsIsLoading(false));
      }
      // Clear any previous error on success
      dispatch(setDetailsError(null));
    } else {
      // Handle error responses (forbidden, not found, etc.)
      const errorMessage = resp.error || resp.message || 'Access denied';
      dispatch(setDetailsError(errorMessage));
      dispatch(setPersonaDetailsIsLoading(false));
    }
    dispatch(setPersonaListLoading(false));
  };

  const params = { bId, indexId, campaignId };

  arClient.doApiCallGet(`/audiences/${bId}/segments/${indexId}`, callback);
  //arClient.doApiCall('/persona/fetchLoaderDetail', params, callback);


  dispatch(setPersonaDetailsIsLoading(true));
  dispatch(setPersonaListLoading(true));
  dispatch(setDetailsError(null)); // Clear error at start of request
};

export const getAudienceDetails = (bId, indexId, campaignId) => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        // Clear any previous error
        dispatch(setDetailsError(null));
        // Use custom predicate to handle string/number type mismatch from URL params
        const req = _.find(resp.data, item => String(item.builderRequestId) === String(bId));
        // Handle both data structures:
        // 1. respData is an array/indexed object: use respData[indexId]
        // 2. respData is the persona object itself (has promptDetails, user_input, etc.): use respData directly
        let personaData = null;
        if (req?.respData) {
          if (req.respData[indexId] !== undefined) {
            personaData = req.respData[indexId];
          } else if (req.respData.promptDetails !== undefined || req.respData.user_input !== undefined) {
            personaData = req.respData;
          }
        }

        if (personaData) {
          dispatch(updatePersonaDetails(personaData));
          resolve(personaData);
        } else {
          reject();
        }
      } else {
        // Handle error responses (forbidden, not found, etc.)
        const errorMessage = resp.error || resp.message || 'Access denied';
        dispatch(setDetailsError(errorMessage));
        reject(errorMessage);
      }
      dispatch(setPersonaDetailsIsLoading(false));
    };

    dispatch(setPersonaDetailsIsLoading(true));
    arClient.doApiCall(
      '/persona/fetchLoaderDetail',
      { bId, indexId, campaignId },
      callback
    );
  });
};

export const getPersonasList = (
  listOnly = false,
  bId = false,
  indexId = false
) => async (dispatch, getState) => {
  // Create a cache key based on the parameters
  const cacheKey = `${listOnly}_${bId}_${indexId}`;

  // Check if data is already cached
  const { Personas } = getState();
  if (Personas.personaListCache[cacheKey]) {
    const cachedData = Personas.personaListCache[cacheKey];
    dispatch(setPersonaList(cachedData));

    if (listOnly === false && bId !== false) {
      // Use custom predicate to handle string/number type mismatch from URL params
      const req = _.find(cachedData, item => String(item.builderRequestId) === String(bId));
      // Handle both data structures:
      // 1. respData is an array/indexed object: use respData[indexId]
      // 2. respData is the persona object itself (has outline, promptDetails, user_input, etc.): use respData directly
      let personaData = null;
      if (req?.respData) {
        if (req.respData[indexId] !== undefined) {
          personaData = _.cloneDeep(req.respData[indexId]);
        } else if (
          req.respData.promptDetails !== undefined ||
          req.respData.user_input !== undefined ||
          req.respData.outline !== undefined ||
          req.respData.demographicsV3 !== undefined
        ) {
          personaData = _.cloneDeep(req.respData);
        }
      }

      if (personaData) {
        const { primaryInterests } = personaData;
        if (!_.isArray(primaryInterests)) {
          // convert the old structure to the new one
          personaData.primaryInterests = _.keys(primaryInterests);
        }
        dispatch(updatePersonaDetails(personaData));
      }
      dispatch(setPersonaDetailsIsLoading(false));
    }
    dispatch(setPersonaListLoading(false));
    return;
  }

  const callback = resp => {
    // dispatch(setPersonaDetailsIsLoading(false));
    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
      // Store data in cache
      dispatch(setPersonaListCache({ cacheKey, data: resp.data }));
      // dispatch(setResultsList(resp.data));
      dispatch(setPersonaList(resp.data));

      if (listOnly === false && bId !== false) {
        // Use custom predicate to handle string/number type mismatch from URL params
        const req = _.find(resp.data, item => String(item.builderRequestId) === String(bId));
        // Handle both data structures:
        // 1. respData is an array/indexed object: use respData[indexId]
        // 2. respData is the persona object itself (has promptDetails, user_input, etc.): use respData directly
        let personaData = null;
        if (req?.respData) {
          if (req.respData[indexId] !== undefined) {
            personaData = _.cloneDeep(req.respData[indexId]);
          } else if (req.respData.promptDetails !== undefined || req.respData.user_input !== undefined) {
            personaData = _.cloneDeep(req.respData);
          }
        }

        if (personaData) {
          const { primaryInterests } = personaData;
          if (!_.isArray(primaryInterests)) {
            // convert the old structure to the new one
            personaData.primaryInterests = _.keys(primaryInterests);
          }
          dispatch(updatePersonaDetails(personaData));
        }
        dispatch(setPersonaDetailsIsLoading(false));
      }
    }
    dispatch(setPersonaListLoading(false));
  };

  const params = listOnly ? { listOnly } : { bId, indexId };

  arClient.doApiCall('/persona/fetch', params, callback);

  dispatch(setPersonaDetailsIsLoading(true));
  dispatch(setPersonaListLoading(true));
};

export const setSelectedCamoaigns = selectedCampaign => async dispatch => {
  dispatch(setPersonaCreationSelectedCampaigns(selectedCampaign));
};

export const cancelGetSuggestionCall = () => async dispatch => {
  dispatch(setPersonaCreationSuggestedInterestsCanceled(true));
  dispatch(setPersonaCreationSuggestedInterests([]));
  dispatch(setPersonaHashtagKeywordsCanceled(true));
  dispatch(setPersonaHashtagKeywords([]));
  dispatch(setPersonaSEOKeywordsCanceled(true));
  dispatch(setPersonaSEOKeywords([]));
};

export const getSuggestedInterests = (interestList, focusedKeyword) => async (
  dispatch,
  getState
) => {
  // dispatch(setPersonaCreationSuggestedInterests(dummyDataInterestsSuggested));
  const {
    Personas: { personaCreationSuggestedInterestsCanceled },
  } = getState();

  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (personaCreationSuggestedInterestsCanceled) {
        dispatch(setPersonaCreationSuggestedInterestsCanceled(false));
        dispatch(setPersonaCreationSuggestedInterests([]));
        resolve(true);
        return;
      } else {
        resolve(true);
        if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200 && resp.data.filtered) {
          dispatch(setPersonaCreationSuggestedInterests(resp.data.filtered));
        }
      }
    };

    arClient.doApiCall(
      '/persona/getSimilarInterests',
      {
        interestList: JSON.stringify(interestList),
        focusedKeyword,
      },
      callback
    );
  });
};

export const getHashtagKeywords = (interestList, focusedKeyword) => async (
  dispatch,
  getState
) => {
  const {
    Personas: { personaHashtagKeywordsCanceled },
  } = getState();

  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (personaHashtagKeywordsCanceled) {
        dispatch(setPersonaHashtagKeywordsCanceled(false));
        dispatch(setPersonaHashtagKeywords([]));
        resolve(true);
        return;
      } else {
        resolve(true);
        if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200 && resp.data) {
          dispatch(setPersonaHashtagKeywords(resp.data));
        }
      }
    };

    arClient.doApiCall(
      '/persona/getHashtagKeywords',
      {
        interestKeyword: JSON.stringify(interestList),
        focusedKeyword,
      },
      callback
    );
  });
};

export const getSEOKeywords = (interestList, focusedKeyword) => async (
  dispatch,
  getState
) => {
  const {
    Personas: { personaSEOKeywordsCanceled },
  } = getState();

  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (personaSEOKeywordsCanceled) {
        dispatch(setPersonaSEOKeywordsCanceled(false));
        dispatch(setPersonaSEOKeywords([]));
        resolve(true);
        return;
      } else {
        resolve(true);
        if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200 && resp.data) {
          dispatch(setPersonaSEOKeywords(resp.data));
        }
      }
    };

    arClient.doApiCall(
      '/persona/getSeoKeywords',
      {
        interestKeyword: JSON.stringify(interestList),
        focusedKeyword,
      },
      callback
    );
  });
};

export const resetsGPTAnswers = () => async dispatch =>
  dispatch(resetChatGPTAnswers());

export const getGPTAnswers = (
  focusedKeyword,
  quesNo,
  context = '',
  campaignId
) => {
  // dispatch(setPersonaCreationSuggestedInterests(dummyDataInterestsSuggested));

  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200 && resp.data?.data) {
        // dispatch(setPersonaCreationSuggestedInterests(resp.data));
        resolve(resp.data);
      }

      reject(resp);
    };

    arClient.doApiCall(
      '/persona/getAnswers',
      {
        focusedKeyword,
        quesNo,
        context,
        campaignId,
      },
      callback
    );
  });
};

export const setSelectedInterests = (
  interestList,
  focusedKeyword,
  campaignId
) => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status !== 10) {
        dispatch(setPersonaCreateErrorMsg(resp.error));
        reject(resp.error);
      } else {
        dispatch(updatePersonaCreateSuccess(resp.status === LEGACY_OK || resp.status === OK || resp.status === 200));
        dispatch(
          setPersonaCreateBuilderRequestDataId(resp.builderRequestDataId)
        );
        resolve(resp);
      }
    };

    arClient.doApiCall(
      '/persona/addUpdate',
      {
        campaignId,
        status: 'Active',
        interestList: JSON.stringify(interestList),
        focusedKeyword,
      },
      callback
    );
  });
};

export const setFiltersActiveNetwork = activeNetwork => async dispatch => {
  dispatch(setPersonaCreationFiltersActiveNetwork(activeNetwork));
};

export const resetSelectedNetworkFilters = network => async dispatch => {
  dispatch(resetFiltersForNetwork(network));
};

export const setNetworkDefaultFilters = (
  network,
  filter,
  valueObj,
  validation,
  noMaxLimit
) => async (dispatch, getState) => {
  const { from, to } = valueObj || {};

  let value = {};
  let data = {};

  if (filter === 'subscribers_count') {
    value = noMaxLimit ? { from } : { from, to };
    data = {
      network,
      filter,
      value,
      noMaxLimit,
    };
  } else if (filter === 'influencer_followers') {
    data = {
      network,
      filter,
      value: valueObj,
      noMaxLimit,
    };
  } else {
    value = valueObj;
    data = {
      network,
      filter,
      value,
      noMaxLimit: getState().Personas.personaCreationFilters[network]
        .noMaxLimit,
    };
  }

  dispatch(setFilterValue(data));

  // Handling data validation
  if (validation !== undefined) {
    const validationArr = getState().Personas.personaCreationFilters[network]
      .invalidFields;

    const newValidationArr = validation
      ? validationArr.filter(item => item !== filter)
      : validationArr.includes(filter)
        ? validationArr
        : [...validationArr, filter];

    dispatch(
      setFilterSysVal({
        network,
        filter: 'invalidFields',
        value: newValidationArr,
      })
    );
  }
};

export const setNetworkFilterValue = (
  network,
  filter,
  valueObj,
  validation,
  noMaxLimit
) => async (dispatch, getState) => {
  const { from, to } = valueObj || {};

  let value = {};
  let data = {};

  const currentFilters = getState().Personas.personaCreationFilters;

  if (network === 'instagram') {
    if (!currentFilters['tiktok'].selectedForSubmit) {
      dispatch(
        setNetworkDefaultFilters(
          'tiktok',
          filter,
          valueObj,
          validation,
          noMaxLimit
        )
      );
    }
    if (!currentFilters['youtube'].selectedForSubmit) {
      dispatch(
        setNetworkDefaultFilters(
          'youtube',
          filter,
          valueObj,
          validation,
          noMaxLimit
        )
      );
    }
  }

  if (filter === 'subscribers_count') {
    value = noMaxLimit ? { from } : { from, to };
    data = {
      network,
      filter,
      value,
      noMaxLimit,
    };
  } else if (filter === 'influencer_followers') {
    data = {
      network,
      filter,
      value: valueObj,
      noMaxLimit,
    };
  } else {
    value = valueObj;
    data = {
      network,
      filter,
      value,
      noMaxLimit: getState().Personas.personaCreationFilters[network]
        .noMaxLimit,
    };
  }

  dispatch(setFilterValue(data));

  // Handling of "Untouched" state and autosaving.
  if (
    data.filter !== 'selectedForSubmit' &&
    data.filter !== 'isUntouched' &&
    data.filter !== 'isSaving'
  ) {
    dispatch(setFilterSysVal({ network, filter: 'isUntouched', value: false }));

    dispatch(
      setFilterSysVal({ network, filter: 'selectedForSubmit', value: true })
    );
  }

  if (data.filter === 'selectedForSubmit') {
    dispatch(
      setFilterSysVal({ network, filter: 'selectedForSubmit', value: true })
    );
  }

  // Handling data validation
  if (validation !== undefined) {
    const validationArr = getState().Personas.personaCreationFilters[network]
      .invalidFields;

    const newValidationArr = validation
      ? validationArr.filter(item => item !== filter)
      : validationArr.includes(filter)
        ? validationArr
        : [...validationArr, filter];

    dispatch(
      setFilterSysVal({
        network,
        filter: 'invalidFields',
        value: newValidationArr,
      })
    );
  }
};

export const resetResultPersonas = () => async dispatch => {
  dispatch(resetResultsList());
};

export const getResultList = () => async dispatch => {
  const callback = resp => {
    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
      dispatch(setResultsList(resp.data));
    }
    dispatch(setResultsListLoading(false));
  };

  dispatch(setResultsListLoading(true));
  arClient.doApiCall('/persona/fetchAll', {}, callback);
};

export const updatePersonaCreateErrorMsg = msg => async dispatch => {
  dispatch(setPersonaCreateErrorMsg(msg));
};

export const updatePersonaCreateSuccess = status => async dispatch => {
  dispatch(setPersonaCreateSuccess(status));
};
export const resetAllPersonaDetails = () => async dispatch => {
  dispatch(resetPersonaDetails());
};

export const fetchPersonaDetailsByIds = (requestId, personaId) => async (
  dispatch,
  getState
) => {
  const {
    Personas: { personaList },
  } = getState();
  // Use custom predicate to handle string/number type mismatch from URL params
  const req = _.find(personaList, item => String(item.builderRequestId) === String(requestId));
  if (req && req.respData) {
    // Handle both data structures:
    // 1. respData is an array/indexed object: use respData[personaId]
    // 2. respData is the persona object itself (has promptDetails, user_input, etc.): use respData directly
    let personaData = null;
    if (req.respData[personaId] !== undefined) {
      personaData = req.respData[personaId];
    } else if (req.respData.promptDetails !== undefined || req.respData.user_input !== undefined) {
      personaData = req.respData;
    }

    if (personaData) {
      dispatch(updatePersonaDetails(personaData));
    }
  }

  dispatch(setPersonaDetailsIsLoading(false));
};

export const fetchPersonaDetailsById = personaId => async dispatch => {
  const callback = resp => {
    dispatch(setPersonaDetailsIsLoading(false));
    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
      const personaData = resp.data[0];

      dispatch(updatePersonaDetails(personaData));

      // dispatch(setPersonaDetailsSummary(personaSummaryDummyData));
    } else {
    }
  };

  dispatch(setPersonaDetailsIsLoading(true));
  arClient.doApiCall(
    '/persona/fetchPersonaDetailsById',
    { personaId },
    callback
  );
};

export const getPostCommentsByIds = (
  rid,
  pid,
  primaryInterest,
  secondaryInterest
) => async dispatch => {
  const callback = resp => {
    dispatch(setPostContentIsLoading(false));
    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
      dispatch(setPostContentByIds({ [secondaryInterest]: resp.data }));

    } else {
      dispatch(setPostContentByIds({}));
    }
  };
  dispatch(setPostContentIsLoading(true));
  arClient.doApiCall(
    '/persona/fetchPostsCommentsById',
    { builderRequestId: rid, indexId: pid, primaryInterest, secondaryInterest },
    callback
  );
};

export const getPostCommentsByIdsV2 = (rid, pid, primaryInterest) => async (
  dispatch,
  getState
) => {
  const cacheKey = `${rid}_${pid}_${primaryInterest || 'null'}`;

  // Check if data is already cached
  const { Personas } = getState();
  if (Personas.commentsV2Cache[cacheKey]) {
    dispatch(setCommentsV2(Personas.commentsV2Cache[cacheKey]));
    return;
  }

  const callback = resp => {
    dispatch(setPostContentIsLoading(false));
    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
      // Store data in cache
      dispatch(setCommentsV2Cache({ cacheKey, data: resp.data }));
      dispatch(setCommentsV2(resp.data));

    } else {
      dispatch(setCommentsV2({}));
    }
  };
  dispatch(setPostContentIsLoading(true));
  arClient.doApiCall(
    '/persona/fetchPostsCommentsV2',
    { builderRequestId: rid, indexId: pid, primaryInterest },
    callback
  );
};

export const clearCommentsV2CacheAction = () => async dispatch => {
  dispatch(clearCommentsV2Cache());
};

export const getCreatorsByIds = (rid, pid, campaignId) => async dispatch => {

  const callback = resp => {

    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
      // Clear any previous error
      dispatch(setInfluencerListError(null));
      if (resp?.indStdER?.length > 0) {
        dispatch(setInfluencerER(resp.indStdER));
      }
      if (resp.data.length > 0) {
        const formattedList = resp.data.reduce((resultArr, currVal) => {
          return Array.isArray(currVal)
            ? resultArr.concat(
              currVal
                .filter(item => !_.isEmpty(item.normalizedRespData))
                .map(formatCreatorDataListingV3)
            )
            : resultArr;
        }, []);
        // Deduplicate by platform + username so a creator active on multiple networks
        // keeps a separate entry per network (dedupe only true duplicates)
        const deduplicatedList = _.uniqBy(
          formattedList,
          (c) => `${(c.socialNetworks?.[0] ?? '').toLowerCase()}|${(c.username ?? '').toLowerCase()}`
        );
        dispatch(setInfluencerListContent(deduplicatedList));
        if (resp.indStdER.length > 0) {
          dispatch(setInfluencerER(resp.indStdER));
        }
      } else {
        dispatch(setInfluencerListContent([]));
      }
    } else {
      // Handle error responses (forbidden, not found, etc.)
      const errorMessage = resp.error || resp.message || 'Access denied';
      dispatch(setInfluencerListError(errorMessage));
      dispatch(setInfluencerListContent([]));
    }
    dispatch(setInfluencerLoadingState(false));
    dispatch(setInfluencerERLoadingState(false));
  };
  dispatch(setInfluencerLoadingState(true));
  dispatch(setInfluencerERLoadingState(true));
  dispatch(setInfluencerListError(null));

  arClient.doApiCall(
    '/creator/fetchAllV3',
    { builderRequestId: rid, indexId: pid, campaignId },
    callback
  );
};

export const getCreatorsByMagicLinkId = (
  magicLinkId,
  hashCode
) => async dispatch => {
  dispatch(setInfluencerLoadingState(true));
  dispatch(setInfluencerERLoadingState(true));

  try {
    // Direct fetch WITHOUT auth — magic link endpoints are public.
    // arClient.doApiCall() requires a Bearer token and silently fails
    // with "Authentication required" when no user is logged in, which
    // caused the "Oops, This Link Has Expired" false-positive for every
    // non-authenticated visitor opening a magic link.
    const response = await fetch(`${API_HOST}/magic-link/get-inf-list`, {
      credentials: 'include',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ magicLinkId, hashCode }),
    });

    const resp = await response.json();

    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
      const dataArray = resp.data?.data || [];
      if (dataArray.length > 0) {
        const isNestedArray = Array.isArray(dataArray[0]);
        let formattedList;
        if (isNestedArray) {
          formattedList = dataArray.reduce((resultArr, currVal) => {
            return Array.isArray(currVal)
              ? resultArr.concat(currVal.map(formatCreatorDataListingV3))
              : resultArr;
          }, []).filter(item => MAGIC_LINK_INFLUENCER_DISPLAY.includes(item.status));
        } else {
          formattedList = dataArray
            .map(formatCreatorDataListingV3)
            .filter(item => MAGIC_LINK_INFLUENCER_DISPLAY.includes(item.status));
        }
        dispatch(setInfluencerListContent(formattedList));
      } else {
        dispatch(setInfluencerListContent([]));
      }

      dispatch(setInfluencerLoadingState(false));
      dispatch(setInfluencerERLoadingState(false));

      return resp.data?.row || { expiryDate: null };
    }

    dispatch(setInfluencerLoadingState(false));
    dispatch(setInfluencerERLoadingState(false));
    throw new Error(resp.message || 'Failed to load magic link');
  } catch (e) {
    dispatch(setInfluencerLoadingState(false));
    dispatch(setInfluencerERLoadingState(false));
    throw e;
  }
};

/**
 * @param {boolean} list return a list of demographics when it is true, otherwise return latest record
 * @returns
 */
export const fetchDemographicData = (
  builderRequestId,
  segmentId,
  list = false
) => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        resolve(resp.data);
      } else {
        resolve({});
      }
    };

    arClient.doApiCall(
      '/creator/fetchDemographics',
      { builderRequestId, segmentId, list: list ? 1 : 0 },
      callback
    );
  });
};

export const addInfluencerManually = (
  builderRequestId,
  segmentId,
  infURLArray
) => dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        dispatch(getCreatorsByIds(builderRequestId, segmentId));
        resolve(resp);
      } else {
        dispatch(setPersonaCreateErrorMsg('Error adding influencer manually'));
        reject(resp);
      }
    };

    arClient.doApiCall(
      '/creator/addInfByURLs',
      {
        builderRequestId,
        segmentId,
        infURLArray: JSON.stringify(infURLArray),
      },
      callback
    );
  });
};

export const getCreatorDetailsById = rid => async dispatch => {
  const callback = resp => {
    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
      resp.data.indStdER = resp.indStdER;
      dispatch(setInfluencerDetailsContent(resp.data));
      dispatch(setInfluencerDetailsLoadingState(false));
      if (resp.indStdER) {
        dispatch(setInfluencerER(resp.indStdER));
        dispatch(setInfluencerERLoadingState(false));
      }
    } else {
      dispatch(setInfluencerDetailsLoadingState(false));
      dispatch(setInfluencerERLoadingState(false));
    }
  };
  dispatch(setInfluencerDetailsLoadingState(true));
  dispatch(setInfluencerERLoadingState(true));
  arClient.doApiCall(
    '/creator/getReportByIdV2',
    { creatorReportDetailsId: rid },
    callback
  );
};

export const getCreatorDetailsByMagicLink = (
  magicLinkId,
  hashCode,
  creatorReportDetailsId
) => async dispatch => {
  const callback = resp => {
    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
      resp.data.indStdER = resp.indStdER;
      dispatch(setInfluencerDetailsContent(resp.data));
      dispatch(setInfluencerDetailsLoadingState(false));
      if (resp.indStdER) {
        dispatch(setInfluencerER(resp.indStdER));
        dispatch(setInfluencerERLoadingState(false));
      }
    } else {
      dispatch(setInfluencerDetailsLoadingState(false));
      dispatch(setInfluencerERLoadingState(false));
    }
  };
  dispatch(setInfluencerDetailsLoadingState(true));
  dispatch(setInfluencerERLoadingState(true));
  magicLinkApiCall('/magic-link/get-inf-details', { magicLinkId, hashCode, creatorReportDetailsId }).then(callback);
};

export const getCreatorsBrandSafetyByRequestID = (
  builderRequestId,
  creatorReportDetailsId
) => async dispatch => {
  dispatch(setInfluencersBrandSafteyLoading(true));

  const callback = resp => {
    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {

      // Check if brandSafetyV3 format exists, otherwise use legacy resp.data
      const brandSafetyData = resp.brandSafetyV3 || resp.data;
      const isBrandSafetyV3 = !!resp.brandSafetyV3;

      if (!_.isEmpty(brandSafetyData)) {
        let infData;

        if (isBrandSafetyV3) {

          // eslint-disable-next-line eqeqeq
          infData = brandSafetyData.creatorReportDetailsId == creatorReportDetailsId
            ? brandSafetyData
            : null;
          dispatch(setInfluencersBrandSafteyData([brandSafetyData]));
        } else {
          infData = brandSafetyData?.find(
            // eslint-disable-next-line eqeqeq
            influencer =>
              influencer.creatorReportDetailsId == creatorReportDetailsId
          );
          dispatch(setInfluencersBrandSafteyData(brandSafetyData));
        }

        if (infData) {
          const { userFeedbackData } = infData;
          dispatch(
            setPostBrandSafetyFeedbackArr(
              userFeedbackData
                ? userFeedbackData.map(parseUserFeedbackRecord)
                : []
            )
          );
        } else {
          // If no matching influencer found, set empty feedback array
          dispatch(setPostBrandSafetyFeedbackArr([]));
        }
      } else {
      }
    } else {
    }
    dispatch(setInfluencersBrandSafteyLoading(false));
  };

  arClient.doApiCall(
    '/persona/getBrandSafetyV2',
    { personaBuilderRequestId: builderRequestId, creatorReportDetailsId },
    callback
  );
};

export const getCreatorNotesByRId = rid => async dispatch => {
  const callback = resp => {
    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
      dispatch(setInfluencerNotesContent(JSON.parse(resp.data.all.notes)));
      dispatch(setInfluencerNotesLoadingState(false));
    } else {
    }
  };
  dispatch(setInfluencerNotesLoadingState(true));
  arClient.doApiCall(
    '/creator/getReportById',
    { creatorReportDetailsId: rid },
    callback
  );
};

export const getCreatorNotesByRId2 = rid => async dispatch => {
  const callback = resp => {
    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
      dispatch(setInfluencerNotesContent(JSON.parse(resp.data[0].notes)));
      dispatch(setInfluencerNotesLoadingState(false));
    } else {
      dispatch(setInfluencerNotesLoadingState(false));
    }
  };
  dispatch(setInfluencerNotesContent([]));
  dispatch(setInfluencerNotesLoadingState(true));
  arClient.doApiCall(
    '/creator/getNotes',
    { creatorReportsDetailId: rid },
    callback
  );
};

export const updateCreatorNotesByRId = (crid, notes) => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        dispatch(setInfluencerNotesContent(notes));
        dispatch(updateInfluencerListNotes({ detailsId: crid, notes }));
        dispatch(setInfluencerNotesLoadingState(false));
        resolve();
      } else {
        dispatch(setInfluencerNotesLoadingState(false));
        reject();
      }
    };

    dispatch(setInfluencerNotesLoadingState(true));

    const notesArr = JSON.stringify(notes);

    arClient.doApiCall(
      '/creator/addnotes',
      {
        creatorReportsDetailId: crid,
        note: notesArr,
      },
      callback
    );
  });
};

export const updateCreatorNotesByMagicLink = (
  magicLinkId,
  hashCode,
  crid,
  notes
) => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        dispatch(setInfluencerNotesContent(notes));
        dispatch(updateInfluencerListNotes({ detailsId: crid, notes }));
        dispatch(setInfluencerNotesLoadingState(false));
        resolve();
      } else {
        dispatch(setInfluencerNotesLoadingState(false));
        reject();
      }
    };

    dispatch(setInfluencerNotesLoadingState(true));

    const notesArr = JSON.stringify(notes);

    magicLinkApiCall('/magic-link/add-notes', { magicLinkId, hashCode, creatorReportDetailsId: crid, note: notesArr }).then(callback);
  });
};

/**
 * Re-fetch an influencer's current notes and RESOLVE with the parsed array,
 * unlike `getCreatorNotesByRId2`, which only dispatches to state.
 *
 * Used to merge against the latest server state right before saving, so a
 * concurrent note added by another workspace member is not overwritten
 * (AAPU-6092).
 *
 * @param {(string|number)} crid - The influencer's creatorReportsDetailId.
 * @returns {import('redux-thunk').ThunkAction<Promise<(Array|null)>, *, *, *>}
 *   Thunk resolving to the parsed notes array, or `null` on failure so the
 *   caller can fall back to saving its local copy.
 */
export const fetchCreatorNotesLatest = crid => async dispatch => {
  dispatch(setInfluencerNotesLoadingState(true));
  try {
    const resp = await arClient.doApiCallAsync('/creator/getNotes', {
      creatorReportsDetailId: crid,
    });
    const raw = resp && resp.data && resp.data[0] ? resp.data[0].notes : null;
    return raw ? JSON.parse(raw) : [];
  } catch (error) {
    return null;
  }
};

/**
 * Magic-link variant of {@link fetchCreatorNotesLatest}. Resolves with the
 * influencer's current notes parsed from the shared-link endpoint (note the
 * response shape differs from the authenticated path: `resp.data.notes` here
 * vs `resp.data[0].notes`).
 *
 * @param {string} magicLinkId - The shared magic-link id.
 * @param {string} hashCode - The magic-link hash/verification code.
 * @param {(string|number)} crid - The influencer's creatorReportDetailsId.
 * @returns {import('redux-thunk').ThunkAction<Promise<(Array|null)>, *, *, *>}
 *   Thunk resolving to the parsed notes array, or `null` on failure.
 */
export const fetchCreatorNotesLatestByMagicLink = (
  magicLinkId,
  hashCode,
  crid
) => async dispatch => {
  dispatch(setInfluencerNotesLoadingState(true));
  try {
    const resp = await magicLinkApiCall('/magic-link/get-notes', {
      magicLinkId,
      hashCode,
      creatorReportDetailsId: crid,
    });
    if (!(resp.status === LEGACY_OK || resp.status === OK || resp.status === 200)) {
      return null;
    }
    const raw = resp && resp.data ? resp.data.notes : null;
    return raw ? JSON.parse(raw) : [];
  } catch (error) {
    return null;
  }
};

export const updateCreatorDetailsInsight = (
  rid,
  insights
) => async dispatch => {
  const callback = resp => {
    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
      dispatch(setInfluencerDetailsInsight(insights));
      dispatch(setInfluencerDetailsLoadingState(false));
    } else {
      dispatch(setInfluencerDetailsLoadingState(false));
    }
  };
  dispatch(setInfluencerDetailsLoadingState(true));
  arClient.doApiCall(
    '/creator/addUpdateInsights',
    { creatorReportsDetailId: rid, insights },
    callback
  );
};

export const updateCreatorDetailsProsnCons = (
  rid,
  prosCons
) => async dispatch => {
  const callback = resp => {
    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
      dispatch(setInfluencerDetailsProsCons(prosConsObj));
      dispatch(setInfluencerDetailsLoadingState(false));
    } else {
      dispatch(setInfluencerDetailsLoadingState(false));
    }
  };
  dispatch(setInfluencerDetailsLoadingState(true));

  const prosConsObj = JSON.stringify(prosCons);

  arClient.doApiCall(
    '/creator/addUpdateProsCons',
    { creatorReportsDetailId: rid, prosCons: prosConsObj },
    callback
  );
};

export const updateCreatorBudget = (rid, budget) => async dispatch => {
  const callback = resp => {
    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
      dispatch(setInfluencerDetailsLoadingState(false));
    } else {
      dispatch(setInfluencerDetailsLoadingState(false));
    }
  };
  dispatch(setInfluencerDetailsLoadingState(true));

  arClient.doApiCall(
    '/creator/addUpdateBudget',
    { creatorReportsDetailId: rid, budget: budget },
    callback
  );
};

export const updatePersonaStatus = (rid, pid, status) => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      dispatch(setPersonaStatusUpdateLoading(false));
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        resolve(resp);
      } else {
        reject(resp);
      }
    };

    dispatch(setPersonaStatusUpdateLoading(true));

    arClient.doApiCall(
      '/persona/updateStatusById',
      { builderRequestId: rid, indexId: pid, status },
      callback
    );
  });
};

export const updateRejectInf = rejectObj => async dispatch => {
  return new Promise((resolve, reject) => {

    const callback = resp => {
      dispatch(setPersonaStatusUpdateLoading(false));
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        resolve(resp);
      } else {
        reject(resp);
      }
    };

    dispatch(setPersonaStatusUpdateLoading(true));

    arClient.doApiCall(
      '/creator/reject',
      { rejectObj: JSON.stringify(rejectObj) },
      callback
    );
  });
};

export const updateInfluStatus = (
  builderRequestId,
  segmentId,
  rejectObj
) => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      dispatch(setInfluencerLoadingState(false));
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        resolve(resp);
      } else {
        reject(resp);
      }
    };

    dispatch(setInfluencerLoadingState(true));

    arClient.doApiCall(
      '/creator/updateStatus',
      {
        builderRequestId,
        segmentId,
        statusObj: JSON.stringify(rejectObj),
      },
      callback
    );
  });
};

export const rejectOutreach = ({
  outreachId,
  to,
  bcc = JSON.stringify([]),
  cc = JSON.stringify([]),
  subject,
  bodyHTML,
  parentGmailId = null,
  senderInfo = JSON.stringify({
    platform: 'default',
    oauthInfoId: null,
  }),
  isInitialEmail = false,
}) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    const sanitizedBodyHTML = stripFroalaAttribution(bodyHTML);

    const callback = resp => {
      if (resp.status === 'INIT' || resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        resolve(true);
      } else {
        reject();
      }
    };

    const payload = {
      subject,
      bodyHTML: sanitizedBodyHTML,
      to,
      bcc,
      cc,
      outreachId,
      senderInfo,
      isInitialEmail,
    };

    if (parentGmailId !== null) {
      payload.parentGmailId = parentGmailId;
    }
    arClient.doApiCall('/outreach/reject', payload, callback);
  });
};

export const updateInfluStatusNonAuth = (
  magicLinkId,
  hashCode,
  statusObj
) => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      dispatch(setInfluencerLoadingState(false));
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        resolve(resp);
      } else {
        reject(resp);
      }
    };

    dispatch(setInfluencerLoadingState(true));

    magicLinkApiCall('/magic-link/update-status', { magicLinkId, hashCode, statusObj: JSON.stringify(statusObj) }).then(callback);
  });
};

export const updatePersonaName = (rid, pid, name) => async dispatch => {
  const callback = resp => {
  };

  arClient.doApiCall(
    '/persona/updateNameById',
    { builderRequestId: rid, indexId: pid, name },
    callback
  );
};

export const updateCreatorFilter = (rid, respData) => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        setCreatorFiltersSavedSuccess(true);
        resolve(true);
      } else {
        setCreatorFiltersSavedErrMsg(
          'API Failed! Something went wrong. Please try again.'
        );
        reject('API Failed! Something went wrong. Please try again.');
      }
    };



    arClient.doApiCall(
      '/persona/setCreatorFilters',
      {
        builderRequestId: rid,
        respData,
      },
      callback
    );
  });
};

export const checkPersonaForSavedFilters = rid => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        if (!_.isEmpty(resp.data)) {
          try {
            dispatch(
              setFiltersFromSaved(reconcileCreatorFiltersData(resp.data))
            );
          } catch (error) {
          }
        }

        dispatch(setFiltersLoadingState(false));
        resolve(true);
      } else {
        dispatch(setFiltersLoadingState(false));
        reject('API Failed! Something went wrong. Please try again.');
      }
    };

    dispatch(setFiltersLoadingState(true));

    arClient.doApiCall(
      '/persona/getCreatorFilters',
      {
        builderRequestId: rid,
      },
      callback
    );
  });
};

export const runInfService = (
  requestId,
  serviceName,
  segmentId
) => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        resolve(resp);
      } else {
        reject(resp);
      }
    };

    arClient.doApiCall(
      '/creator/runService',
      {
        requestId,
        serviceName,
        segmentId,
      },
      callback
    );
  });
};

export const fetchPersonaSegmentByIds = (
  requestId,
  segmentId
) => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {

      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        // return only the segment data
        const segmentData = resp.data[0]?.respData;
        if (segmentData) {
          const { primaryInterests } = segmentData;
          if (!_.isArray(primaryInterests)) {
            segmentData.primaryInterests = _.keys(primaryInterests);
          }
        }
        resolve(segmentData);
        dispatch(updatePersonaDetails(segmentData));
      } else {
        reject(resp);
      }
      dispatch(setPersonaDetailsIsLoading(false));
    };

    arClient.doApiCall(
      '/persona/fetchLoaderDetail',
      { bId: requestId, indexId: segmentId },
      callback
    );
  });
};

export const fetchPersonaSegmentByMagicLinkId = (magicLinkId, hashCode) => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        resolve(resp.data);
      } else {
        reject(resp);
      }
    };

    magicLinkApiCall('/magic-link/fetch-lite', { magicLinkId, hashCode }).then(callback);
  });
};

export const updateIsCompareActive = (status, cmpId) => async dispatch => {
  dispatch(setIsCompareActive(status));
  dispatch(setComparePersonaCampaign(cmpId));
};

export const updateSelectedPersonaForCompArr = personaIdArr => async dispatch => {
  dispatch(setSelectedPersonaForCompArr(personaIdArr));
};

export function fetchPersonasForComparison(personIdArr) {
  function fetchPersonaDetails(params) {
    return new Promise((resolve, reject) => {
      const callback = resp => {
        if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200 && resp.data) {
          resolve(resp.data);
        }
        reject(resp);
      };
      arClient.doApiCall('/persona/fetchLoaderDetail', params, callback);
    });
  }

  return Promise.all(
    personIdArr.map(({ requestId, segmentId }) =>
      fetchPersonaDetails({ bId: requestId, indexId: segmentId })
    )
  ).then(data => {
    return data.map((item, idx) => {
      const { requestId, segmentId } = personIdArr[idx];
      return {
        data: item[0]?.respData,
        requestId,
        segmentId,
      };
    });
  });
}

export const getContentInfluencer = creatorReportDetailsId => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if ((resp?.status === 10 || resp?.status === 'OK' || resp?.status === 200) || resp?.status === 'INIT') {
        if (resp.creatorDetailsData) {
          const formattedData = formatContentData(resp);
          dispatch(setInfluencerContent(formattedData));
        } else {
          dispatch(setInfluencerContent([]));
        }
        resolve(resp);
      } else {
        dispatch(setInfluencerContent([]));
        reject(resp);
      }

      dispatch(setInfluencerContentLoadingState(false));
    };

    dispatch(setInfluencerContentLoadingState(true));

    arClient.doApiCall(
      '/creator/getContent',
      { creatorReportDetailsId },
      callback,
      {}
    );
  });
};

export const getMatchingContentInfluencer = (
  creatorReportDetailsId,
  personaBuilderRequestId,
  segmentId
) => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp?.status === 10 || resp?.status === 'OK' || resp?.status === 200) {
        if (resp.creatorDetailsData) {
          const formattedData = formatContentData(resp);
          dispatch(setInfluencerMatchingContent(formattedData));
        } else {
          dispatch(setInfluencerMatchingContent([]));
        }
        resolve(resp);
      } else {
        dispatch(setInfluencerMatchingContent([]));
        reject(resp);
      }

      dispatch(setInfluencerMatchingContentLoading(false));
    };

    dispatch(setInfluencerMatchingContentLoading(true));

    arClient.doApiCall(
      '/persona/post-recommend-details',
      { personaBuilderRequestId, creatorReportDetailsId, segmentId },
      callback,
      {}
    );
  });
};

export const getRevisionsDataInfluencer = creatorReportDetailsId => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      dispatch(setIsInfluencerRevisionsFoundLoading(false));

      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        if (!_.isEmpty(resp.data)) {
          dispatch(
            setIsInfluencerRevisionsFound(
              resp.data.contentRevisionDetails[0]?.contentRevisionId
            )
          );
          dispatch(
            setContentAgreementData({
              id: resp.data.id,
              agreementList: JSON.parse(resp.data.contentJson),
            })
          );
        } else {
          dispatch(setIsInfluencerRevisionsFound(false));
        }
        resolve(resp);
      } else {
        reject(resp);
      }
    };

    dispatch(setIsInfluencerRevisionsFoundLoading(true));
    arClient.doApiCall(
      '/content-revision/createUpdate',
      { creatorReportDetailsId },
      callback,
      {}
    );
  });
};

export const getRevisionsList = contentRevisionId => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      //dispatch(setIsInfluencerRevisionsListLoading(false));

      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        if (!_.isEmpty(resp.data)) {
          dispatch(setInfluencerRevisionsList(resp.data));
        } else {
          dispatch(setInfluencerRevisionsList([]));
        }
        dispatch(setIsInfluencerRevisionsListLoading(false));
        resolve(resp);
      } else {
        dispatch(setInfluencerRevisionsList([]));
        dispatch(setIsInfluencerRevisionsListLoading(false));
        reject(resp);
      }
    };

    dispatch(setIsInfluencerRevisionsListLoading(true));
    arClient.doApiCall(
      '/content-revision/fetchAll',
      { contentRevisionId },
      callback,
      {}
    );
  });
};

export const getRevisionsConversationClient = contentRevisionDetailsId => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      dispatch(setIsInfluencerRevisionsConversationLoading(false));

      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        if (!_.isEmpty(resp.data)) {
          dispatch(setInfluencerRevisionsConversation(resp.data));
        }
        resolve(resp);
      } else {
        reject(resp);
      }
    };

    dispatch(setIsInfluencerRevisionsConversationLoading(true));
    arClient.doApiCall(
      '/content-revision/getConversation',
      { contentRevisionDetailsId },
      callback,
      {}
    );
  });
};

export const sendMessageRevisionsConversationClient = (
  msgObj,
  selectedRevisionId
) => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        if (!_.isEmpty(resp.data)) {
          dispatch(getRevisionsConversationClient(selectedRevisionId));
        }
        resolve(resp);
      } else {
        reject(resp);
      }
    };

    dispatch(setIsInfluencerRevisionsConversationLoading(true));
    arClient.doApiCall(
      '/content-revision/addClientResponse',
      msgObj,
      callback,
      {}
    );
  });
};

export const sendInstructionsRevisionsConversationClient = (
  instructions,
  contentRevisionDetailsId
) => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        if (!_.isEmpty(resp.data)) {
          dispatch(
            setRevisionStatusConversationClient(
              'completed',
              contentRevisionDetailsId
            )
          );
        }
        resolve(resp);
      } else {
        reject(resp);
      }
    };

    dispatch(setIsInfluencerRevisionsConversationLoading(true));
    arClient.doApiCall(
      '/content-revision/addDeliveryInstructions',
      {
        deliveryInstructions: JSON.stringify(instructions),
        contentRevisionDetailsId,
      },
      callback,
      {}
    );
  });
};

export const setRevisionStatusConversationClient = (
  status,
  contentRevisionDetailsId
) => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        dispatch(getRevisionsConversationClient(contentRevisionDetailsId));
        resolve(resp);
      } else {
        reject(resp);
      }
    };

    dispatch(setIsInfluencerRevisionsConversationLoading(true));
    arClient.doApiCall(
      '/content-revision/setStatus',
      { contentRevisionDetailsId, status },
      callback,
      {}
    );
  });
};

export const clearRevisionsConversationClient = () => async dispatch => {
  dispatch(setInfluencerRevisionsConversation({}));
};

export const getAudiencesList = (campaignId = null) => async dispatch => {
  const callback = respApi => {
    if (respApi.status === 10 || respApi.status === 'OK' || respApi.status === 200) {
      dispatch(setAudienceList(respApi.data));
    } else {
      dispatch(setAudienceList([]));
    }
    dispatch(setAudienceListLoadingState(false));
  };

  dispatch(setAudienceListLoadingState(true));

  const params = campaignId === null ? {} : { campaignId };

  arClient.doApiCall('/persona/getPersonaListByCampaignId', params, callback);
};

export const getAudiencesListV2 = (campaignId = null) => async dispatch => {
  const callback = respApi => {
    if (respApi.status === 10 || respApi.status === 'OK' || respApi.status === 200) {
      dispatch(setAudienceList(respApi.data));

      if (respApi?.influencerCounts) {
        dispatch(setInfluencerCount(respApi.influencerCounts));
      }
    } else {
      dispatch(setAudienceList([]));
    }
    dispatch(setAudienceListLoadingState(false));
  };

  dispatch(setAudienceListLoadingState(true));

  const params = campaignId === null ? {} : { campaignId };

  // Use lightweight endpoint - fetches per-segment respData (small) instead of
  // full blob from personaLoaderData (20MB+). Much faster for list views.
  arClient.doApiCall(
    '/persona/getPersonaListByCampaignIdLite',
    params,
    callback
  );
};

export function fetchContentAnalysis(creatorReportDetailsId, creatorPostId) {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      // Check for success status (10 or 'OK')
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        try {
          const respData = JSON.parse(resp.data.respData);
          const formattedData = respData['Posts'].map(item =>
            formatContentAnalysisData(item.analysis, item.meta)
          );
          resolve(formattedData);
        } catch (e) {
          console.error('fetchContentAnalysis parse error:', e);
          resolve([]);
        }
      } else {
        console.error('fetchContentAnalysis error:', resp);
        resolve([]);
      }
    };
    arClient.doApiCall(
      '/creator/fetchAnalysis',
      { creatorReportDetailsId, creatorPostId },
      callback
    );
  });
}

export const getContentRevisionCount = contentRevisionDetailsId => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        resolve(resp);
      } else {
        reject(resp);
      }
    };

    arClient.doApiCall(
      '/content-revision/getConversationCount',
      {
        contentRevisionDetailsId,
      },
      callback
    );
  });
};

export const getContentRevisionInfCount = contentRevisionDetailsId => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        resolve(resp);
      } else {
        reject(resp);
      }
    };

    // Use public API call (no auth required for influencer pages)
    arClient.doPublicApiCall(
      '/custom/get-conversation-count',
      {
        contentRevisionDetailsId,
      },
      callback
    );
  });
};

export const postTikTokAdAccountId = (advertiserId, authCode) => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        resolve(resp);
      } else {
        reject(resp);
      }
    };

    arClient.doApiCall(
      '/tiktok/check-advertiser',
      {
        advertiserId,
        authCode,
      },
      callback
    );
  });
};

export const getPersonaLite = (campaignId = null) => async dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      dispatch(setPersonaLiteListLoading(false));

      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        if (!_.isEmpty(resp.data)) {
          dispatch(setPersonaLiteList(resp.data));
        }
        resolve(resp);
      } else {
        dispatch(setPersonaLiteList([]));
        resolve({ status: 'ERROR', data: [] });
      }
    };

    const params = campaignId ? { campaignId } : {};
    dispatch(setPersonaLiteListLoading(true));
    arClient.doApiCall('/persona/fetchLite', params, callback, {});
  });
};

// Segment status that marks an audience as ready to receive influencers.
export const ACCEPTED_SEGMENT_STATUS = 'Accept';

/**
 * Fetch every audience segment for the account, grouped by campaign, from the
 * lightweight `/persona/getAllSegmentsLite` endpoint. Resolves with the raw
 * grouped array; does NOT write to the Redux store (callers keep it in local
 * state). Consumers filter to accepted segments via `buildLinkableCampaigns`.
 */
export const getAllSegmentsLite = () => () => {
  return new Promise(resolve => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        resolve(_.isArray(resp.data) ? resp.data : []);
      } else {
        console.error('getAllSegmentsLite failed', resp);
        resolve([]);
      }
    };

    arClient.doApiCall('/persona/getAllSegmentsLite', {}, callback, {});
  });
};

/**
 * Transform the raw grouped payload from `getAllSegmentsLite` into the shape the
 * campaign-linking UI needs: only campaigns that have at least one accepted
 * segment, each segment carrying its own builderRequestId + indexId.
 *
 * @param {Array} allSegments grouped segments as returned by the endpoint
 * @returns {Array<{campaignId: string, title: string, audiences: Array}>}
 */
export const buildLinkableCampaigns = (allSegments = []) =>
  (_.isArray(allSegments) ? allSegments : [])
    .map(campaign => ({
      campaignId: String(campaign?.campaignId ?? ''),
      title: campaign?.campaignName || '',
      status: campaign?.campaignStatus || '',
      createdTimestamp: campaign?.createdTimestamp ?? null,
      audiences: (campaign?.segments || [])
        .filter(segment => segment?.status === ACCEPTED_SEGMENT_STATUS)
        .map(segment => ({
          key: `${segment.builderRequestId}:${segment.indexId}`,
          title:
            (segment.customName || '').replace(/^\s*,/, '') ||
            `Segment ${segment.indexId}`,
          segmentId: segment.indexId,
          builderRequestId: String(segment.builderRequestId ?? ''),
        })),
    }))
    .filter(campaign => campaign.audiences.length > 0);

export const getCreatorNotesByMagicLink = (
  magicLinkId,
  hashCode,
  creatorReportDetailsId
) => async dispatch => {
  const callback = resp => {
    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
      dispatch(setInfluencerNotesContent(JSON.parse(resp.data.notes)));
      dispatch(setInfluencerNotesLoadingState(false));
    } else {
      dispatch(setInfluencerNotesLoadingState(false));
    }
  };
  dispatch(setInfluencerNotesContent([]));
  dispatch(setInfluencerNotesLoadingState(true));
  magicLinkApiCall('/magic-link/get-notes', { magicLinkId, hashCode, creatorReportDetailsId }).then(callback);
};

export const getCreatorsBrandSafetyByMagicLink = (
  magicLinkId,
  hashCode,
  creatorReportDetailsId
) => async dispatch => {
  const callback = resp => {
    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {

      if (!_.isEmpty(resp.data)) {
        dispatch(setInfluencersBrandSafteyData(resp.data));
      } else {
      }
    } else {
    }
  };

  magicLinkApiCall('/magic-link/get-brand-safety', { magicLinkId, hashCode, creatorReportDetailsId }).then(callback);
};

export const updateBrandSafetyUserFeedback = userFeedbackData => (
  dispatch,
  getState
) => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        const {
          Personas: { postBrandSafetyFeedbackArr },
        } = getState();
        const foundItem = postBrandSafetyFeedbackArr.find(
          item => item.creatorPostId === userFeedbackData?.creatorPostId
        );

        if (foundItem) {
          dispatch(
            setPostBrandSafetyFeedbackArr(
              postBrandSafetyFeedbackArr.map(post => {
                if (post.creatorPostId === userFeedbackData.creatorPostId) {
                  return {
                    ...post,
                    ...userFeedbackData,
                  };
                }
                return post;
              })
            )
          );
        } else {
          dispatch(
            setPostBrandSafetyFeedbackArr([
              ...postBrandSafetyFeedbackArr,
              userFeedbackData,
            ])
          );
        }
        resolve(resp);
      } else {
        reject(resp);
      }
    };

    arClient.doApiCall(
      '/persona/updatePostBrandSafetyFeedback',
      {
        ...userFeedbackData,
        flagFeedback: JSON.stringify(userFeedbackData.flagFeedback),
        notes: JSON.stringify(userFeedbackData.notes),
      },
      callback
    );
  });
};

export const updateCampaignBrandSafetyPreference = (
  campaignId,
  data
) => dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        resolve(resp);
        dispatch(setCampaignBrandSafetyPreference(data));
        // State now holds the just-saved map, so keep it marked as fetched for this campaign —
        // consumers must not refetch after an edit.
        dispatch(setCampaignBrandSafetyPreferenceFetchedId(String(campaignId)));
      } else {
        reject(resp);
      }
    };

    arClient.doApiCall(
      '/campaign/updateBrandSafetyPreference',
      {
        campaignId,
        data: JSON.stringify(data),
      },
      callback
    );
  });
};



export const getCampaignBrandSafetyPreference = campaignId => dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      // Every branch below resolves (this thunk fails open to all-flags-enabled), so the campaign is
      // "fetched" either way — mark it before branching so a failure can't spin into a refetch loop.
      dispatch(setCampaignBrandSafetyPreferenceFetchedId(String(campaignId)));
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        try {
          let prefData = {};
          // Handle both string and object data formats
          if (resp.data && resp.data.data) {
            prefData = typeof resp.data.data === 'string'
              ? JSON.parse(resp.data.data)
              : resp.data.data;
          } else if (resp.data && typeof resp.data === 'object') {
            prefData = resp.data;
          }
          // An empty preference would read as "every flag is off", hiding all issues
          const safePrefData = _.isEmpty(prefData)
            ? allBrandSafetyFlagsEnabled()
            : prefData;
          dispatch(setCampaignBrandSafetyPreference(safePrefData));
          resolve(safePrefData);
        } catch (e) {
          console.error('Failed to parse brand safety preference:', e);
          dispatch(setCampaignBrandSafetyPreference(allBrandSafetyFlagsEnabled()));
          resolve(allBrandSafetyFlagsEnabled());
        }
      } else {
        console.error('API Failed: getCampaignBrandSafetyPreference');
        dispatch(setCampaignBrandSafetyPreference(allBrandSafetyFlagsEnabled()));
        resolve(allBrandSafetyFlagsEnabled());
      }
    };

    arClient.doApiCall(
      '/campaign/getBrandSafetyPreference',
      {
        campaignId,
      },
      callback
    );
  });
};

export const getBrandSafetyData = campaignId => dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        try {
          const brandSafetyData = resp?.brandSafetyV3 || resp?.data || [];
          const feedbackArr = _.flatten(
            (Array.isArray(brandSafetyData) ? brandSafetyData : []).map(
              item => item.userFeedbackData || []
            )
          );

          dispatch(
            setPostBrandSafetyFeedbackArr(
              feedbackArr.map(parseUserFeedbackRecord)
            )
          );
          resolve(brandSafetyData);
        } catch (e) {
          console.error('Failed to parse brand safety data:', e);
          dispatch(setPostBrandSafetyFeedbackArr([]));
          resolve([]);
        }
      } else {
        console.error('API Failed: getBrandSafetyData');
        dispatch(setPostBrandSafetyFeedbackArr([]));
        resolve([]);
      }
    };

    arClient.doApiCall(
      '/campaign/getBrandSafety',
      {
        campaignId,
      },
      callback
    );
  });
};

export const getPostCommentsByFeatureBreakdown = (
  rid,
  pid,
  selectedFilters
) => async (dispatch, getState) => {
  // Create a cache key based on the parameters
  const cacheKey = `${rid}-${pid}-${JSON.stringify(selectedFilters)}`;

  // Check if data is already cached
  const state = getState();
  const cachedData = state.Personas.commentsBreakdownCache[cacheKey];

  if (cachedData) {
    // Data is already cached, use it instead of making API call
    dispatch(setCommentsBreakdown(cachedData));
    return;
  }

  // Check if already loading to avoid duplicate requests
  if (state.Personas.isLoadingCommentsBreakdown) {
    return;
  }

  const callback = resp => {
    dispatch(setIsLoadingCommentsBreakdown(false));
    if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
      dispatch(setCommentsBreakdown(resp.data));
      // Cache the successful response
      dispatch(setCommentsBreakdownCache({ cacheKey, data: resp.data }));

    } else {
      dispatch(setCommentsBreakdown({}));
    }
  };

  dispatch(setIsLoadingCommentsBreakdown(true));
  arClient.doApiCall(
    '/persona/getPostsByFeatureSpace',
    {
      builderRequestId: rid,
      indexId: pid,
      selectedFilters: JSON.stringify(selectedFilters),
    },
    callback
  );
};

export const getHeroInfluencers = (builderRequestId, segmentId) => dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      dispatch(setIsLoadingInfluencerHeroList(false));
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        try {
          const { data } = resp;
          //const prefData = JSON.parse(data);
          dispatch(setInfluencerHeroList(data));
        } catch (e) { }
      } else {
        reject(resp);
      }
    };
    dispatch(setIsLoadingInfluencerHeroList(true));
    arClient.doApiCall(
      '/creator/getHeroInfluencers',
      {
        builderRequestId,
        segmentId,
      },
      callback
    );
  });
};

export const saveHeroInf = userSelection => dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        resolve(resp);
      } else {
        reject(resp);
      }
    };

    arClient.doApiCall(
      '/creator/save-hero-influencer',
      {
        userSelection: JSON.stringify(userSelection),
      },
      callback
    );
  });
};

export const getLookalikes = (builderRequestId, segmentId, discoveryOptions) => dispatch => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200 || resp.status === 'INVALID_DATA') {
        try {
          resolve(resp);
        } catch (e) { }
      } else {
        reject(resp);
      }
    };

    const params = {
      builderRequestId,
      segmentId,
    };

    if (discoveryOptions?.platforms) {
      discoveryOptions.platforms.forEach((p, i) => {
        params[`platforms[${i}]`] = p;
      });
    }

    if (discoveryOptions?.nInfluencers) {
      params.nInfluencers = discoveryOptions.nInfluencers;
    }

    if (discoveryOptions?.nInfluencersPerPlatform) {
      Object.entries(discoveryOptions.nInfluencersPerPlatform).forEach(([p, c]) => {
        params[`nInfluencersPerPlatform[${p}]`] = c;
      });
    }

    arClient.doApiCall(
      '/creator/extendLookALike',
      params,
      callback
    );
  });
};

export const updatePostBrandSafetyStatus = (
  creatorReportDetailsId,
  creatorPostId,
  status
) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    const callback = resp => {
      if (resp.status === LEGACY_OK || resp.status === OK || resp.status === 200) {
        resolve(resp);
        const {
          Personas: { postBrandSafetyFeedbackArr },
        } = getState();
        const foundItem = postBrandSafetyFeedbackArr.find(
          item => item.creatorPostId === creatorPostId
        );

        // if foundItem, update the status
        if (foundItem) {
          dispatch(
            setPostBrandSafetyFeedbackArr(
              postBrandSafetyFeedbackArr.map(post => {
                if (post.creatorPostId === creatorPostId) {
                  return {
                    ...post,
                    status,
                  };
                }
                return post;
              })
            )
          );
          // add a new item to the array
        } else {
          dispatch(
            setPostBrandSafetyFeedbackArr([
              ...postBrandSafetyFeedbackArr,
              {
                creatorReportDetailsId,
                creatorPostId,
                flagFeedback: {},
                notes: [],
                status,
              },
            ])
          );
        }
      }
    };

    arClient.doApiCall(
      '/persona/updatePostBrandSafetyStatus',
      {
        creatorReportDetailsId,
        creatorPostId,
        status,
      },
      callback
    );
  });
};

export default PersonasSlice.reducer;
